// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phase-heading {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.116666px;
  color: var(--theme-main-color, #055C8D);
  margin: 10px 0px 5px 0px;
  padding-top: 10px;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 5px;
}

#value {
  margin-left: auto;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.0897432px;
  color: #8C8C8C;
}

#value:hover {
  color: var(--theme-main-color, #055C8D);
}

.phase-list .phases {
  display: flex;
  padding-right: 32px;
  cursor: pointer;
  margin-bottom: 7px;
}

.phase-list .phases:last-child {
  margin-bottom: 0px;
}

#name {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 17px;
  letter-spacing: -0.0897432px;
  color: #8C8C8C;
  padding-left: 10px;
}

#name:hover {
  color: var(--theme-main-color, #055C8D);
}

.noItem {
  color: #8C8C8C;
  font-size: 14px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
